import React from "react";
import PropTypes from "prop-types";
import { Box } from "@sainsburys-tech/fable";
import EnergyChart from "../EnergyChart";
import moment from "moment";
import apiProxy from "../../api/apiProxy";

const loadSensorData = apiProxy.sensor.getData;

const EnergyMainMeterSensorEnergyChart = props => (
  <Box className="drop-shadow">
    <EnergyChart
      sensorId={props.sensorId}
      showSeriesLabel={false}
      storeId={props.storeId}
      title={
        <React.Fragment>
          <h4>Main grid consumption</h4>
          <p>Main consumption is not live</p>
        </React.Fragment>
      }
      dataResolution="ThirtyMinutes"
      date={moment()
        .subtract(1, "days")
        .toDate()}
      hasBaseline={false}
      window="W"
      actualsSeriesLabel="Main grid consumption"
      hasAlerts={false}
      maxEndDate={{
        date: moment()
          .subtract(1, "days")
          .toDate(),
        buttonText: "Show Latest"
      }}
      loadSensorData={loadSensorData}
    />
  </Box>
);

EnergyMainMeterSensorEnergyChart.propTypes = {
  sensorId: PropTypes.string.isRequired,
  storeId: PropTypes.string.isRequired
};

export default EnergyMainMeterSensorEnergyChart;
